import {
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const options: any = {
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: { display: false },
    tooltip: {
      borderColor: '#D2D2D2',
      borderWidth: 1,
      displayColors: false,
      callbacks: {
        label: (context: any) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const data = context.raw || ''
          return `${
            data > 1 ? `${data} stickers` : `${data || '0'} sticker`
          }, ${context.label}`
        },
        title: () => {
          return ''
        }
      },
      backgroundColor: 'white',
      titleColor: 'black',
      bodyColor: 'black',
      bodyFont: {
        size: 14,
        weight: 700
      },
      xAlign: 'left',
      yAlign: 'top'
    }
  },
  maintainAspectRatio: false,
  layout: { autoPadding: true, padding: 2 },
  scales: {
    x: {
      display: true,
      ticks: {
        display: false
      },
      grid: {
        display: false,
        drawBorder: true
      }
    },
    y: {
      display: false
    }
  },
  interaction: {
    intersect: false,
    mode: 'nearest',
    axis: 'x'
  }
}

function AssessmentTrendByIntervalChart({
  backgroundColor,
  chartData,
  labels
}: {
  backgroundColor: string
  chartData: number[]
  labels: string[]
}) {
  const data: ChartData<'bar', number[], string> = {
    labels,
    datasets: [
      {
        data: chartData,
        backgroundColor,
        borderRadius: 2,
        borderSkipped: false,
        barPercentage: 0.9,
        categoryPercentage: 1
      }
    ]
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return <Bar options={options} data={data} />
}

export default AssessmentTrendByIntervalChart
